import { IconButton, Tooltip, Typography, Box } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { FaExpandAlt } from "react-icons/fa";
import { RiCollapseDiagonal2Fill } from "react-icons/ri";
import { useState } from "react";
import React from "react";
import { useModal } from "../context/ModalContext";

const CopyableText: React.FC<{ value: string; previewLength?: number }> = ({
  value,
  previewLength = 15,
}) => {
  const [copied, setCopied] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const { showModal } = useModal();

  const preview = value?.length > previewLength ? value?.slice(0, previewLength) + "…" : value || "";

  const handleCopy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1200);
  };

  const toggleExpanded = () => {
    // display full value in a <pre> element in the modal
    if (!expanded) {
      showModal({
        title: "Full Text",
        message: value,
        preventClose: true,
        displayAsPre: true,
        onCancel: () => setExpanded(false),
      });
    } else {
      setExpanded(false);
    }
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1, width: "100%" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      {!expanded ? 
      (<Typography variant="body2" sx={{ fontFamily: "monospace" }}>
        {preview}
      </Typography>)
      :
      (<Typography variant="body2" sx={{ fontFamily: "monospace", whiteSpace: "pre-wrap", wordBreak: "break-word", backgroundColor: "#292929", padding: 1, borderRadius: 1 }}>
        {value}
      </Typography>)
      }

      <Tooltip title={copied ? "Copied!" : "Copy"}>
        <IconButton size="small" onClick={handleCopy}>
        <ContentCopyIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
      <Tooltip title={expanded ? "Collapse" : "Expand"}>
        <IconButton size="small" onClick={toggleExpanded}>
        {expanded ? <RiCollapseDiagonal2Fill size={12} /> : <FaExpandAlt size={12} />}
        </IconButton>
      </Tooltip>
      </Box>
    </Box>
  );
};
export default CopyableText;